document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.js-collection-swatch');
  if (!swatch) return;
  if (!document.body.classList.contains('template-collection')) return;

  e.preventDefault();

  const card = swatch.closest('.product-card');
  if (!card) return;

  const jsonEl = card.querySelector('.js-group-products');
  if (!jsonEl) return;

  const data = JSON.parse(jsonEl.textContent);
  const productId = swatch.dataset.productId;

  const product = data.products.find(p => String(p.id) === productId);
  if (!product) return;

  const variant = product.variants[0];

  /* ================= IMAGE (MAIN) ================= */
  const mainImg = card.querySelector('.product-card__image--main img');
  if (mainImg && product.featured_image) {
    mainImg.src = product.featured_image;
    mainImg.srcset = '';
    mainImg.alt = product.title;
  }

  /* ================= IMAGE (SECOND / HOVER) ================= */
  const secondImg = card.querySelector('.product-card__image--second img');
  if (secondImg && product.images && product.images.length > 1) {
    secondImg.src = product.images[1];
    secondImg.srcset = '';
    secondImg.alt = product.title;
  }

  /* ================= URL ================= */
  const productURL = card.querySelector('.product-card__link');
  const productUrl = `${window.Shopify.routes.root}products/${product.handle}`;
  
  if (productURL) {
    productURL.href = productUrl;
  }

  /* ================= TITLE ================= */
  const titleEl = card.querySelector('.product-card__title');
  if (titleEl) {
    titleEl.textContent = product.title;
  }

  /* ================= PRICE ================= */
  const priceWrap = card.querySelector('[data-product-price]');  
  if (priceWrap && variant) {
    priceWrap.innerHTML = formatMoney(variant.price, window.FoxThemeSettings.money_format);
  }

  /* ================= ATC VARIANT ================= */
  const atcInput = card.querySelector('input[name="id"]');
  if (atcInput && variant) {
    atcInput.value = variant.id;
  }

  /* ================= ACTIVE STATE ================= */
  const swatches = Array.from(
    card.querySelectorAll('.color-swatch__item')
  );

  swatches.forEach(el => el.classList.remove('is-active'));
  swatch.classList.add('is-active');

  /* ================= MOVE SELECTED SWATCH FIRST ================= */
  const swatchContainer = swatch.closest('.color-swatch');
  if (swatchContainer) {
    swatchContainer.prepend(swatch);
  }
});
